const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/
const DATE_TIME_WITH_OFFSET_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:?\d{2})$/

// All-day tactics/initiatives represent a calendar date with no meaningful time of day,
// but the API returns them as precise UTC instants (e.g. "2026-07-28T04:00:00+00:00").
// Naively reading the viewer's local calendar date off that instant can roll the date
// back a day for any viewer in a timezone west of whichever timezone the value was
// originally saved from - which varies per record, since it depends on the creator's
// location at save time, not any fixed reference zone. Read the calendar date directly
// off the UTC digits instead (no timezone conversion at all), then anchor it to local
// noon so it can't shift for any viewer - consistent with how recurrenceEndDate is
// normalized.
export function parseAllDayDate(value: string): Date {
  if (typeof value !== 'string') {
    return new Date(value)
  }

  if (DATE_ONLY_PATTERN.test(value)) {
    return new Date(`${value}T12:00:00`)
  }

  if (DATE_TIME_WITH_OFFSET_PATTERN.test(value)) {
    const instant = new Date(value)
    const year = instant.getUTCFullYear()
    const month = String(instant.getUTCMonth() + 1).padStart(2, '0')
    const day = String(instant.getUTCDate()).padStart(2, '0')
    return new Date(`${year}-${month}-${day}T12:00:00`)
  }

  return new Date(value)
}
